import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { blogPosts } from '../../../mocks/blogPosts';

const SocialShare = () => {
  const { slug } = useParams();
  const post = blogPosts.find(p => p.slug === slug);
  const [copied, setCopied] = useState(false);

  if (!post) return null;

  const currentUrl = window.location.href;
  const shareText = `${post.title} - ${post.excerpt}`;

  const shareLinks = {
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentUrl)}`,
    twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(currentUrl)}`,
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(currentUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy link:', err);
    }
  };

  return (
    <div className="flex items-center space-x-4 py-6 border-t border-b border-gray-200 my-8">
      <span className="text-gray-700 font-medium">Share this article:</span>
      
      <div className="flex items-center space-x-3">
        <a
          href={shareLinks.linkedin}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-10 h-10 bg-blue-600 hover:bg-blue-700 text-white rounded-full transition-colors"
          aria-label="Share on LinkedIn"
        >
          <i className="ri-linkedin-fill text-lg"></i>
        </a>
        
        <a
          href={shareLinks.twitter}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-10 h-10 bg-black hover:bg-gray-800 text-white rounded-full transition-colors"
          aria-label="Share on Twitter"
        >
          <i className="ri-twitter-x-fill text-lg"></i>
        </a>
        
        <button
          onClick={copyToClipboard}
          className="flex items-center justify-center w-10 h-10 bg-gray-600 hover:bg-gray-700 text-white rounded-full transition-colors relative"
          aria-label="Copy link"
        >
          <i className={`ri-${copied ? 'check' : 'link'}-line text-lg`}></i>
          {copied && (
            <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-gray-900 text-white text-xs px-2 py-1 rounded whitespace-nowrap">
              Link copied!
            </div>
          )}
        </button>
      </div>
    </div>
  );
};

export default SocialShare;